const SORT_LOCALE = "de";

const ALPHA_COLLATOR_OPTIONS = {
    sensitivity: "base",
    numeric: true,
    ignorePunctuation: true,
};

/**
 * Sortiert die Items innerhalb aller passenden Wrapper nach der gewählten Reihenfolge.
 * Jeder Wrapper wird für sich sortiert.
 *
 * @param {string} wrapperClass     Klasse oder fertiger Selektor der Wrapper (z. B. "swiper-wrapper")
 * @param {string} itemClass        Klasse oder fertiger Selektor der Items (z. B. "swiper-slide")
 * @param {string} sort             "date" | "popular" | "alpha"
 * @param {string} [containerClass] Optionaler äußerer Container, auf den die Suche
 *                                  nach Wrappern eingegrenzt wird (z. B. "sort-popular").
 *                                  Ohne Angabe wird das gesamte Dokument durchsucht.
 */
export function sortItems(wrapperClass, itemClass, sort, containerClass) {
    if (!sort) return;

    const roots = containerClass
        ? Array.from(document.querySelectorAll(toSelector(containerClass)))
        : [document];

    if (!roots.length) return;

    roots.forEach((root) => {
        root.querySelectorAll(toSelector(wrapperClass)).forEach((wrapper) => {
            const items = Array.from(wrapper.querySelectorAll(toSelector(itemClass)));
            if (items.length < 2) return;

            items
                .sort((a, b) => compareItems(a, b, sort))
                .forEach((item) => wrapper.appendChild(item));
        });
    });
}

/**
 * Vergleicht zwei Items anhand der gewählten Sortierung.
 */
function compareItems(a, b, sort) {
    if (sort === "date") {
        return getDate(b) - getDate(a);
    }

    if (sort === "popular") {
        // Items ohne gültigen Wert landen am Ende.
        return getPopular(b) - getPopular(a);
    }

    if (sort === "alpha") {
        return getHeadlineText(a).localeCompare(
            getHeadlineText(b),
            SORT_LOCALE,
            ALPHA_COLLATOR_OPTIONS,
        );
    }

    return 0;
}

/**
 * Erlaubt sowohl reine Klassennamen ("swiper-wrapper") als auch fertige Selektoren ("#items", ".item").
 */
function toSelector(value) {
    return /^[.#[]/.test(value) ? value : `.${value}`;
}

/**
 * Zeitstempel aus data-date. Ungültige Werte zählen als 0.
 */
function getDate(item) {
    const ts = Date.parse((item.dataset.date || "").trim());

    return Number.isFinite(ts) ? ts : 0;
}

/**
 * Beliebtheit aus data-popular. Ungültige Werte landen am Ende der Sortierung.
 */
function getPopular(item) {
    const value = Number.parseFloat((item.dataset.popular || "").trim());

    return Number.isFinite(value) ? value : Number.MIN_SAFE_INTEGER;
}

/**
 * Text für die alphabetische Sortierung: ausschließlich die sichtbare Headline.
 */
function getHeadlineText(item) {
    return (item.querySelector(".weekly__headline")?.textContent || "")
        .replace(/\s+/g, " ")
        .trim();
}